var map = {
	"./amex.png": 972,
	"./diners.png": 973,
	"./discover.png": 974,
	"./jcb.png": 975,
	"./maestro.png": 1204,
	"./mastercard.png": 976,
	"./stripe.png": 977,
	"./union.png": 978,
	"./unknown.png": 661,
	"./visa.png": 979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1203;